import { StackProps } from "react-bootstrap";
import { ITestableComponentProps } from "../../../shared/types/testing.types";

export interface IPageControlsProps
  extends StackProps,
    ITestableComponentProps {}

export const DefaultPageControlsProps: IPageControlsProps = {
  direction: "horizontal",
};
